










































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import Rule from '@/modules/seo/components/analysis/Rule.vue'

/**
 * Regla que muestra la legibilidad del texto
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ReadabilityRule extends Rule {
    public resultMap = [
        {
            start: 0,
            end: 40,
            color: 'red',
            textColor: 'red--text',
            text: 'El texto es muy dificil de leer',
            equivalentDifficulty: 'Texto universitario o cientifico',
        },
        {
            start: 40,
            end: 55,
            color: 'orange',
            textColor: 'orange--text',
            text: 'El texto es algo dificil de leer',
            equivalentDifficulty: 'Bachillerato, divulgación cientifica, prensa especializada',
        },
        {
            start: 55,
            end: 65,
            color: 'yellow darken-3',
            textColor: 'yellow--text text--darken-3',
            text: 'La dificultad de lectura del texto es normal',
            equivalentDifficulty: 'E.S.O, prensa general, prensa deportiva',
        },
        {
            start: 65,
            end: 80,
            color: 'cyan',
            textColor: 'cyan--text',
            text: 'El texto es bastante facil de leer',
            equivalentDifficulty: 'Educación primaria, prensa del corazón, novelas de éxito',
        },
        {
            start: 80,
            end: 101,
            color: 'blue',
            textColor: 'blue--text',
            text: 'El texto es muy facil de leer',
            equivalentDifficulty: 'Educación primaria, tebeos, cómic',
        },
    ]

    get result () {
        return this.resultMap.find(v => _.inRange(this.score, v.start, v.end))
    }

    get color (): string {
        if (this.noCalculable) {
            return 'grey'
        }

        const result = this.result
        if (!result) {
            return 'dark'
        }

        return result.color
    }

    get equivalentDifficulty (): string {
        const result = this.result
        if (!result) {
            return '???'
        }

        return result.equivalentDifficulty
    }

    get text (): string {
        const result = this.result
        if (!result) {
            return 'No se puede calcular la dificultad del texto'
        }

        return result.text
    }

    get score (): number {
        const score = this.value.getAttribute('score', 0) as number

        // Si la puntuación es mayor a 100 se limita el resultado para no romper
        // el gráfico
        if (score > 100) {
            return 100
        }

        return score
    }

    get fixedScore (): string {
        const score = this.score
        if (Number.isInteger(score)) {
            return score.toFixed(0)
        }

        return score.toFixed(2)
    }

    get wordCount (): number {
        return this.value.getAttribute('wordCount', 0) as number
    }

    get syllableCount (): number {
        return this.value.getAttribute('syllables', 0) as number
    }

    get sentenceCount (): number {
        return this.value.getAttribute('sentenceCount', 0) as number
    }

    get noCalculable (): boolean {
        return this.value.getAttribute('noCalculableText', false)
    }

    get textColor (): string {
        if (this.noCalculable) {
            return 'grey'
        }

        const result = this.result
        if (!result) {
            return 'dark'
        }

        return result.textColor || result.color || 'dark'
    }
}
